import { render } from "./CustomerSectionAddress.vue?vue&type=template&id=427620ec"
import script from "./CustomerSectionAddress.vue?vue&type=script&lang=js"
export * from "./CustomerSectionAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__